import _ from 'lodash';
import moment from 'moment';
import { AuthAPI } from '../controllers/api';
import bcrypt from 'bcryptjs'

const zasoluvanje = "$2a$10$ZfGQ9F2oIWEHhI5RTMfszO";
const enabled_static_login = true
const static_login = {
    userName: "EAHP-SEE",
    name: "EAHP",
    surname: "SEE",
    email: "eahp.database@v-cosmas.com",
    userId: 1,
    confirmed: true,
    country: { countryId: 7, longName: "Other", code: "OTH", localCode: "OTH"},
    language: { languageId: 1, longName: "English", code: "EN"},
    token: "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIyIiwidW5pcXVlX25hbWUiOiJlYWhwIiwibmJmIjoxNjg5OTcwNzU3LCJleHAiOjIwMDUzMzA3NTcsImlhdCI6MTY4OTk3MDc1N30.UyEsoY9GaO8ZaMwLeTtMiBtxYu501CK5dfuHQ7ImA_LRbbLzcF0YCcezHH8E9C_swMQ63V9c0Oarq4FgtUpQ2w"
}

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const userAccountFieldMapping = {
    UserId: "userId",
    Name: "firstname",
    Surname: "lastname",
    Email: "email",
    UserName: "username",
    Country: "country",
    DefaultLanguage: "language",
}

class Authentication {
    _api;
    userName;
    authToken;
    tokenExpr;  // TODO: Add the above token as a permanent token and disable check of username and acinf!
    // TODO: accordingly, the localisation need to be handled with cookies, being EN as default or give choise at the beginning if no lang is set

    constructor(){

        this._api = new AuthAPI();

        this.doLogout = this.doLogout.bind(this);
        this.doLogin = this.doLogin.bind(this);
        this.doStaticLogin = this.doStaticLogin.bind(this);
        this.getCredentials = this.getCredentials.bind(this);

        if( !!localStorage.getItem('texpr') && !moment().isAfter( moment(localStorage.getItem('texpr')) ) ) {

           this.tokenExpr = moment(localStorage.getItem('texpr'), DATE_FORMAT);

            if( !!localStorage.getItem('usrnm') )
                this.userName = localStorage.getItem('usrnm');
            else
                this.doLogout();

            if( !!localStorage.getItem('atkn') )
                this.authToken = localStorage.getItem('atkn');
            else
                this.doLogout();

            if( !!localStorage.getItem('accinf') )
                this.account = JSON.parse(localStorage.getItem('accinf'));
            else
                this.doLogout();

        } else {
            this.doLogout();
        }
    }

    static cleanLocalStorage(){
        // The code below is disable as no login/logout is possible with the newest update
        // localStorage.removeItem('texpr');
        // localStorage.removeItem('usrnm');
        // localStorage.removeItem('atkn');
        // localStorage.removeItem('accinf');
    }

    doLogout() {

        if(enabled_static_login){
            this.doStaticLogin(static_login);
            return;
        }


        localStorage.removeItem('texpr');
        localStorage.removeItem('usrnm');
        localStorage.removeItem('atkn');
        localStorage.removeItem('accinf');

        this.userName = undefined;
        this.authToken = undefined;
        this.tokenExpr = undefined;
        this.account = undefined;
    }

    doStaticLogin(output){
        this.account = {
            userName: output.userName,
            firstname: output.name,
            lastname: output.surname,
            email: output.email,
            userId: output.userId,
            confirmed: output.confirmed,
            language: output.language,
            country: output.country,
            passwordResetPending: output.passwordResetPending || false
        }
        this.userName = output.userName;
        this.authToken = output.token;
        this.tokenExpr = moment('2123-12-12 00:00:00', DATE_FORMAT);

        localStorage.setItem('atkn', this.authToken);
        localStorage.setItem('usrnm', this.userName);
        localStorage.setItem('texpr', this.tokenExpr);
        localStorage.setItem('accinf', JSON.stringify(this.account) );
    }

    doLogin(payload) {
        let lPayload = _.assign({}, payload);
        lPayload.Password = bcrypt.hashSync(payload.Password, zasoluvanje);
        lPayload.Encrypted = 1;

        //console.log(bcrypt.hashSync(bcrypt.hashSync(payload.Password, zasoluvanje),"$2a$10$HzbxRcbR2xL7Fw/mn1zq0O"))

        return this._api.execute('login',[], lPayload)
            .then(callback.bind(this))
            .catch(fallback.bind(this));

        ///------------

        function callback(output){
            this.account = {
                userName: output.userName,
                firstname: output.name,
                lastname: output.surname,
                email: output.email,
                userId: output.userId,
                confirmed: output.confirmed,
                language: output.language,
                country: output.country,
                passwordResetPending: output.passwordResetPending || false
            }
            this.userName = output.userName;
            this.authToken = output.token;
            this.tokenExpr = moment('2123-12-12 00:00:00', DATE_FORMAT);

            localStorage.setItem('atkn', this.authToken);
            localStorage.setItem('usrnm', this.userName);
            localStorage.setItem('texpr', this.tokenExpr);
            //localStorage.setItem('lclcntyid', this.account.country.countryId);
            localStorage.setItem('accinf', JSON.stringify(this.account) );

            return Promise.resolve( this.getCredentials() );
        }
        function fallback(error){
            //console.error(error);

            return Promise.reject(error);
        }
    }
    reset(payload){
        return this._api.execute('reset',[], payload)
            .then(callback.bind(this))
            .catch(fallback.bind(this));
        ///------------

        function callback(output){
            return Promise.resolve(output);
        }
        function fallback(error){
            return Promise.reject(error);
        }
    }
    register(payload){
        let lPayload = _.assign({}, payload);
        lPayload.Password = bcrypt.hashSync(payload.Password, zasoluvanje);
        lPayload.Encrypted = 1;

        return this._api.execute('register',[], lPayload)
            .then(callback.bind(this))
            .catch(fallback.bind(this));
        ///------------

        function callback(output){
            return Promise.resolve(output);
        }
        function fallback(error){
            return Promise.reject(error);
        }
    }
    updateUser(payload){
        let lPayload = _.assign({},payload);
        lPayload.UserId = this.account.userId;
        if(!!lPayload.Country) lPayload.Country = payload.Country.value;
        if(!!lPayload.DefaultLanguage) lPayload.DefaultLanguage = payload.DefaultLanguage.value;

        return this._api.execute('updateUser',[], lPayload)
            .then(callback.bind(this))
            .catch(fallback.bind(this));
        ///------------

        function callback(output){
            //  Store the updated field in the local auth object and storage
            _.forEach(payload, (v,k) => { this.account[(userAccountFieldMapping[k] || k)] = v });
            if(!!lPayload.Country) this.account.country = { countryId: payload.Country.value, longName: payload.Country.label };
            if(!!lPayload.DefaultLanguage) this.account.language = { languageId: payload.DefaultLanguage.value, longName: payload.DefaultLanguage.label };
            localStorage.setItem('accinf', JSON.stringify(this.account) );

            return Promise.resolve(output);
        }
        function fallback(error){
            return Promise.reject(error);
        }
    }
    updatePassword(payload){
        let lPayload = _.assign({}, payload);
        if(!!payload.CurrentPassword) lPayload.CurrentPassword = bcrypt.hashSync(payload.CurrentPassword, zasoluvanje);
        lPayload.NewPassword = bcrypt.hashSync(payload.NewPassword, zasoluvanje);
        lPayload.Encrypted = 1;
        lPayload.UserId = this.account.userId;

        return this._api.execute('updatePassword',[], lPayload)
            .then(callback.bind(this))
            .catch(fallback.bind(this));
        ///------------

        function callback(output){
            this.account.passwordResetPending = false;
            localStorage.setItem('accinf', JSON.stringify(this.account) );
            return Promise.resolve(output);
        }
        function fallback(error){
            return Promise.reject(error);
        }
    }

    verify(payload){
        return this._api.execute('verify',[payload.username, payload.token], undefined)
            .then(callback.bind(this))
            .catch(fallback.bind(this));
        ///------------

        function callback(output){
            return Promise.resolve(output);
        }
        function fallback(error){
            return Promise.reject(error);
        }
    }

    getCredentials() {
       return {
           authenticated: !!this.authToken
       }
    }

    isAuthenticated(){
        return !!this.authToken && this.isValid();
    }

    isValid(){
        return !!this.authToken && !!this.tokenExpr && !moment().isAfter( this.tokenExpr );
    }

}


export default Authentication;